import { ProductStates } from '../../../../..';
import { onSearchResultsShown } from '../../../../../../common/analytics';
import { ResultsShownActionSubjectId } from '../../../../../../common/analytics/events';
import { type CommonAttributes } from './product-state-analytics-types';

export const errorAnalyticsGenerator = (
	productState: ProductStates,
	commonAttributes: CommonAttributes,
	previousState: ProductStates,
) => {
	if (
		previousState !== ProductStates.PreQueryLoading &&
		previousState !== ProductStates.PostQueryLoading
	) {
		return;
	}
	switch (productState) {
		case ProductStates.PreQueryError:
		case ProductStates.PostQueryError:
			return onSearchResultsShown({
				actionSubjectId:
					productState === ProductStates.PreQueryError
						? ResultsShownActionSubjectId.PREQUERY_ERROR
						: ResultsShownActionSubjectId.POSTQUERY_ERROR,
				resultCount: 0,
				sectionCount: 0,
				results: [],
				...commonAttributes,
			});
		default:
			break;
	}
};
